import { forwardRef } from "react"
import { Tag } from "./Tag"
import { useMultiSelect } from "./Root"
import { flexCss } from "../Flex"
import { styled } from "../styles"

export type ListProps = React.ComponentPropsWithRef<typeof StyledList>

const List: React.FC<ListProps> = forwardRef((props, forwardedRef) => {
  const { state, dispatch } = useMultiSelect(`List`)

  return (
    <StyledList ref={forwardedRef} {...props}>
      {state.tags.map((tag) => (
        <Tag key={tag} onRemove={() => dispatch({ type: `removeTag`, tag })}>
          {tag}
        </Tag>
      ))}
    </StyledList>
  )
})

const StyledList = styled.div({
  ...flexCss,
  display: `inline-flex`,
  flexShrink: 0,
  flexWrap: `wrap`,
})

List.displayName = `MultiSelectList`

export { List }
